// Mock data for bharat-calculator.com
import { Calculator, Landmark, Heart, Sigma, Percent, Clock, Receipt, CalendarDays, Divide, Home as HomeIcon, TrendingUp, PiggyBank, Wallet, Scale, BookOpen, Briefcase, Activity, Baby, Timer, GraduationCap, Key, Grid3x3 } from 'lucide-react';

export const FEATURED_CALCULATORS = [
  { id: 'basic', name: 'Basic Calculator', desc: 'Simple arithmetic with memory keys.', icon: Calculator, color: 'saffron', category: 'Math' },
  { id: 'scientific', name: 'Scientific Calculator', desc: 'Trig, log, exponents and more.', icon: Sigma, color: 'green', category: 'Math' },
  { id: 'emi', name: 'EMI Calculator', desc: 'Calculate monthly EMI in ₹ for loans.', icon: Landmark, color: 'saffron', category: 'Financial' },
  { id: 'sip', name: 'SIP Calculator', desc: 'Project mutual fund SIP returns.', icon: TrendingUp, color: 'green', category: 'Financial' },
  { id: 'mortgage', name: 'Home Loan Calculator', desc: 'Home loan amortization in INR.', icon: HomeIcon, color: 'saffron', category: 'Financial' },
  { id: 'income-tax', name: 'Income Tax Calculator', desc: 'Indian tax slabs FY 2024-25.', icon: Wallet, color: 'green', category: 'Financial' },
  { id: 'bmi', name: 'BMI Calculator', desc: 'Body Mass Index in metric units.', icon: Heart, color: 'saffron', category: 'Fitness' },
  { id: 'age', name: 'Age Calculator', desc: 'Exact age in years, months, days.', icon: Clock, color: 'green', category: 'Other' },
  { id: 'percentage', name: 'Percentage Calculator', desc: 'Percent of, increase/decrease.', icon: Percent, color: 'saffron', category: 'Math' },
  { id: 'gst', name: 'GST Calculator', desc: 'Add or remove GST, auto CGST/SGST.', icon: Receipt, color: 'green', category: 'Financial' },
];

export const CATEGORIES = [
  {
    name: 'Financial Calculators',
    icon: Landmark,
    color: 'saffron',
    items: [
      { id: 'emi', name: 'EMI Calculator' },
      { id: 'mortgage', name: 'Home Loan Calculator' },
      { id: 'sip', name: 'SIP Calculator' },
      { id: 'fd', name: 'FD Calculator' },
      { id: 'ppf', name: 'PPF Calculator' },
      { id: 'gst', name: 'GST Calculator' },
      { id: 'income-tax', name: 'Income Tax Calculator' },
      { id: 'retirement', name: 'Retirement Calculator' },
    ]
  },
  {
    name: 'Fitness & Health',
    icon: Heart,
    color: 'green',
    items: [
      { id: 'bmi', name: 'BMI Calculator' },
      { id: 'bmr', name: 'BMR Calculator' },
      { id: 'calorie', name: 'Calorie Calculator' },
      { id: 'body-fat', name: 'Body Fat Calculator' },
      { id: 'ideal-weight', name: 'Ideal Weight Calculator' },
      { id: 'pace', name: 'Pace Calculator' },
      { id: 'pregnancy', name: 'Pregnancy Calculator' },
      { id: 'due-date', name: 'Due Date Calculator' },
    ]
  },
  {
    name: 'Math Calculators',
    icon: Sigma,
    color: 'saffron',
    items: [
      { id: 'basic', name: 'Basic Calculator' },
      { id: 'scientific', name: 'Scientific Calculator' },
      { id: 'percentage', name: 'Percentage Calculator' },
      { id: 'fraction', name: 'Fraction Calculator' },
      { id: 'ratio', name: 'Ratio Calculator' },
      { id: 'exponent', name: 'Exponent Calculator' },
      { id: 'log', name: 'Log Calculator' },
      { id: 'matrix', name: 'Matrix Calculator' },
    ]
  },
  {
    name: 'Other Calculators',
    icon: Briefcase,
    color: 'green',
    items: [
      { id: 'age', name: 'Age Calculator' },
      { id: 'date', name: 'Date Calculator' },
      { id: 'tip', name: 'Tip Calculator' },
      { id: 'time', name: 'Time Calculator' },
      { id: 'hours', name: 'Hours Calculator' },
      { id: 'grade', name: 'Grade Calculator' },
      { id: 'gpa', name: 'GPA Calculator' },
      { id: 'password', name: 'Password Generator' },
    ]
  },
];

export const RELATED_ARTICLES = [
  { id: 1, title: 'How EMI Works: A Simple Guide for Indian Borrowers', excerpt: 'Understand how banks calculate your Equated Monthly Installment and why longer tenures cost more.', readTime: '5 min read', category: 'Financial' },
  { id: 2, title: 'Understanding BMI in the Indian Context', excerpt: 'Why Asian BMI thresholds differ and how to interpret your body mass index accurately.', readTime: '4 min read', category: 'Health' },
  { id: 3, title: 'GST in India: Slabs, Rates & Calculation', excerpt: 'A beginner-friendly walkthrough of Goods and Services Tax slabs and how to compute it.', readTime: '6 min read', category: 'Tax' },
  { id: 4, title: 'SIP vs Lump Sum: Which is Better for You?', excerpt: 'Explore the pros and cons of systematic investment plans versus one-time investments.', readTime: '7 min read', category: 'Investment' },
];

export const STATS = [
  { label: 'Calculators', value: '32+' },
  { label: 'Daily Users', value: '50K+' },
  { label: 'Languages', value: '2' },
  { label: 'Always Free', value: '100%' },
];
